import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";

import SuiButton from "components/SuiButton";
import ClipLoader from "react-spinners/ClipLoader";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function PaperComponent(props) {
  return (
    <Draggable handle="#my-draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DraggableDialog({
  heading,
  text,
  cancelText = "Cancel",
  okText = "Ok",
  okColor,
  cancelColor,
  visible,
  handleClose,
  handleOk,
  loading = false,
  hideAction = false,
  option = {},
}) {
  return (
    <div>
      <Dialog
        open={visible}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="my-draggable-dialog-title"
        maxWidth="md"
        fullWidth
        {...option}
      >
        <DialogTitle id="my-draggable-dialog-title">
          {heading}
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>{text}</DialogContent>
        {hideAction ? null : (
          <DialogActions>
            {cancelText && (
              <SuiButton
                onClick={handleClose}
                color={cancelColor ? cancelColor : "light"}
                variant="gradient"
              >
                {cancelText}
              </SuiButton>
            )}
            {okText && (
              <SuiButton
                onClick={handleOk}
                autoFocus
                color={okColor ? okColor : "dark"}
                variant="gradient"
              >
                {loading ? (
                  <ClipLoader
                    size={18}
                    color={okColor ? okColor : "#000000"}
                    cssOverride={{ marginRight: 1 }}
                  />
                ) : null}
                <div>{okText}</div>
              </SuiButton>
            )}
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
